import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card } from '../../ui';

import AutosStandardWrapper from './AutosStandard.style';
import Steps from '../../Steps';
import {
  setStepsList,
  setVehiclesValue
} from "../../../actions";
import Login from '../../Common/Login';
import Quotation from './Quotation';
import Payment from './Payment';
import AutoForm_1 from './AutoForm_1';
import AutoForm_2 from '../../Common/Autos/AutoForm_2';
import AutoForm_3 from './AutoForm_3';

class AutosStandard extends Component {

  constructor(props) {
    super(props);

    this.state = {
      globalSteps: ['1. Tus datos', '2. Datos del vehículo', '3. Cotización', '4. Compra'],
      steps: [
        { pos: 0, global:  0, name: 'autoForm_1', backButton: false },
        { pos: 1, global:  1, name: 'autoForm_2' },
        { pos: 2, global:  2, name: 'quotation' },
        { pos: 3, global: -1, name: 'login' },
        { pos: 4, global:  3, name: 'autoForm_3' },
        { pos: 5, global:  3, name: 'payment' },
      ]
    };
  }

  // eslint-disable-next-line camelcase
  componentDidMount() {

    const { steps } = this.state;
    const { setStepsList, setVehiclesValue, economic } = this.props;
    setStepsList(steps);
    setVehiclesValue('vehicleType', 'auto');
    setVehiclesValue('economic', economic);
  }

  getStepContent() {

    const { selectedStep } = this.props;

    switch (selectedStep.name) {
      case 'autoForm_1':
        return <AutoForm_1 />
      case 'autoForm_2':
        return <AutoForm_2 isSOA={false}/>
      case 'quotation':
        return <Quotation />;
      case 'login':
        return <Login />;
      case 'autoForm_3':
        return <AutoForm_3 />
      case 'payment':
        return <Payment />;
    }
  }

  render() {

    const { globalSteps } = this.state;

    return (
      <Card className="Card--medium">
        <AutosStandardWrapper>
          <Steps globalSteps={globalSteps} />
          <div>
            {this.getStepContent()}
          </div>
        </AutosStandardWrapper>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedStep: state.steps.selectedStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: (steps) => {
      dispatch(setStepsList(steps));
    },
    setVehiclesValue: (type, value) => {
      dispatch(setVehiclesValue(type, value));
    },
  };
};

AutosStandard.defaultProps = {
  economic: false
}

export default connect(mapStateToProps, mapDispatchToProps)(AutosStandard);